import * as React from 'react';
import { SxProps, Theme } from '@mui/material';
import Typography from '@mui/material/Typography';

const kwadHubTitle = 'KwadHub';

interface KwadhubTitleProps {
  sx?: SxProps<Theme>;
}

const KwadhubTitle: React.FC<KwadhubTitleProps> = ({ sx }) => {
    return (
        <Typography
            variant="h1"
            noWrap
            component="a"
            href="/"
            sx={{
                ...sx,
                display: 'flex',
            }}
        >
            {kwadHubTitle}
        </Typography>
    );
};

export default KwadhubTitle;
